import { useEffect } from 'react';
import { THEME_MAP } from '@flip7/shared';
import { useAuth } from './AuthContext';

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();
  const themeKey = user?.activeTheme ?? null;

  useEffect(() => {
    const root = document.documentElement;

    if (!themeKey) {
      // Remove any previously applied theme vars
      root.removeAttribute('data-theme');
      const prev = root.dataset.themeVars;
      if (prev) {
        for (const varName of prev.split(',')) {
          root.style.removeProperty(varName);
        }
        delete root.dataset.themeVars;
      }
      return;
    }

    const theme = THEME_MAP[themeKey];
    if (!theme) return;

    root.setAttribute('data-theme', themeKey);
    const varNames: string[] = [];
    for (const [varName, value] of Object.entries(theme.vars)) {
      root.style.setProperty(varName, value);
      varNames.push(varName);
    }
    root.dataset.themeVars = varNames.join(',');

    return () => {
      root.removeAttribute('data-theme');
      for (const varName of varNames) {
        root.style.removeProperty(varName);
      }
      delete root.dataset.themeVars;
    };
  }, [themeKey]);

  return <>{children}</>;
}
